
const swiper2 = new Swiper('.collections-list-slider', {
    direction: 'horizontal',
    slidesPerView: 4.6,
    slidesPerGroup:1,
    centeredSlides: true,
    spaceBetween: 20,
    breakpoints: {
      100: {
        slidesPerView: 1.365,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: true,
        loop:true,
      },
      501: {
        slidesPerView: 2.4,
        spaceBetween: 20,
        slidesPerGroup: 1,
      },
      1024: {
        slidesPerView: 4.6,
        spaceBetween: 20,
        slidesPerGroup: 1,
        centeredSlides: false,
      }
    }
});
